<template>
    <div class="RePhoneCallButton">
        <!-- <div class="d-flex" v-if="typeLink == true">
            <span class="mr-2" @click="callAgent">{{ this.phone }}</span>
        </div> -->
        <base-button @click="callAgent" type="success" :class="[{'no-border': borderStyle=='noborder'}]" class="btn btn-icon mt-0" simple><i class="tim-ic ic-phone pt-1"></i></base-button>
    </div>
</template>
<script>
import { Button } from 'element-ui';
export default {
    name: 'RePhoneCallButton',
    components: {
        [Button.name]: Button,
    },
    props: {
        phone:{
            type: [String, Number],
            default: '',
        },
        lead_id:{
            type: [String, Number],
            default: '',
        },
        borderStyle: {
            type: String,
            default: '',
        },
        beforeCall:{
            type: Function,
            required: false,
        }
        // typeLink:{
        //     type: Boolean,
        //     default: false,
        // }

        
    },
    data () {
        return {
            
        }
    },
    methods: {
        async callAgent(){
            // тут будет АПИ для метода со звонком
            //this.$GVO.ApiCall('staff.GET',{flt:{code:this.agent_model_cache.selectedVal }})
            try{
                if(this.beforeCall){
                    await this.beforeCall()
                }
                const objApi = await this.$GVO.Api.PhoneCallApi.LEAD_CALL({
                    flt:{
                        phone: this.phone, 
                        lead_id: this.lead_id
                    }
                });
                if(objApi.success === true){ 
                    // console.log(objApi.data);
                    // this.bIsShown = true;
                    // this.objCall = objApi.data;
                    // this.objCall = this.$GVO.unlinkObject(objApi.data);
                }else{
                    // this.objCall = {};
                    // this.bIsShown = false;
                    this.$GVO.showAlert('Ошибка',objApi.msg)
                } 
            }catch(errorObjApi){
                // this.objCall = {};
                console.error(errorObjApi);
            };

        },
    }
}
</script>
<style scoped>


</style>